// extracted by mini-css-extract-plugin
export default {"Section":"SchoolLogoSection_Section__euWGJ","SectionTitle":"SchoolLogoSection_SectionTitle__taa89"};